var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-check-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-check-mark",
    fill: "#18814D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,512 C114.844,512 0,397.156 0,256 C0,114.844 114.844,0 256,0 C397.156,0 512,114.844 512,256 C512,397.156 397.156,512 256,512 Z M256,32 C132.484,32 32,132.484 32,256 C32,379.516 132.484,480 256,480 C379.516,480 480,379.516 480,256 C480,132.484 379.516,32 256,32 Z M219.312,347.312 L379.312,187.312 C385.564,181.06 385.564,170.936 379.312,164.688 C373.06,158.44 362.936,158.436 356.688,164.688 L208,313.376 L155.312,260.688 C149.06,254.436 138.936,254.436 132.688,260.688 C126.44,266.94 126.436,277.064 132.688,283.312 L196.688,347.312 C199.812,350.436 203.908,352 208,352 C212.092,352 216.188,350.436 219.312,347.312 Z",
    id: "Check_Mark"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckMark);
export default __webpack_public_path__ + "static/media/icon-check-mark.e99af6808b8038433c45f7794ad95bb4.svg";
export { ForwardRef as ReactComponent };